

export var TerrassorMessages = {


messagesChantier : {
	'init': {
		'type':'info',
		'message':"Renseignez les données globales de votre chantier. <br/>Une fois terminé, et quand vous aurez validé votre saisie, vous pourrez accéder à la création de votre épure.",
		'context':'CHANTIER'
	},
	'running':null, // pas de message

	'end': {
		'type':'info',
		'message':"Vous pouvez maintenant créer votre épure en saisissant les données des cubatures",
		'context':'CHANTIER'
	}
},
    messagesCreationEpure : {
	'init': {
		'type':'info',
		'message':"Créez l'épure de votre chantier en saisissant d'abord ses cubatures. <br/>Une fois terminé, vous pourrez définir vos mouvements de terre.",
		'context':'CREATIONEPURE'
	},
	'mouvements': {
		'type':'info',
		'message':"Saisissez vos mouvements de terre. En cas de besoin vous pouvez toujours corriger les cubatures.",
		'context':'CREATIONEPURE'
	},
	'planification': {
		'type':'info',
		'message':"Si vous n'êtes pas sûr de votre épure, vous pouvez encore la modifier.",
		'context':'CREATIONEPURE'
	},
	'end': {
		'type':'info',
		'message':"Vous pouvez maintenant planifier votre chantier en procédant mouvement par mouvement. <br>Pour accéder à un mouvement, vous devez cliquer son étiquette. Pour obtenir des information sur une cubature, vous devez également cliquer son étiquette. <br/>Une fois que tous les mouvements seront planifiés, vous pourrez procéder à l'installation du chantier. Une fois ces deux étapes validées, vous pourrez lancer la simulation de votre chantier.",
		'context':'CREATIONEPURE'
	}
},


messagesEpure : {
	'init': {
		'type':'info',
		'message':"Planifiez votre chantier en procédant mouvement par mouvement. <br>Pour accéder à un mouvement, vous devez cliquer son étiquette. Pour obtenir des information sur une cubature,  vous devez également cliquer son étiquette. <br/>Une fois que tous les mouvements seront planifiés, vous pourrez procéder à l'installation du chantier. Une fois ces deux étapes validées, vous pourrez lancer la simulation de votre chantier.",
		'context':'EPURE'
	},
	'running':null, // pas de message

	'end': {
		'type':'info',
		'message':"Planifiez votre chantier en procédant mouvement par mouvement. <br>Pour accéder à un mouvement, vous devez cliquer son étiquette. Pour obtenir des information sur une cubature,  vous devez également cliquer son étiquette. <br/>Une fois que tous les mouvements seront planifiés, vous pourrez procéder à l'installation du chantier.Une fois ces deux étapes validées, vous pourrez lancer la simulation de votre chantier.",
		'context':'EPURE'
	}
},

   messagesMouvement : {
	'init': {
		'type':'info',
		'message':"Indiquez quand commencera et quand finira ce mouvement, puis créez un ou des échelons composés d'engins pour optimiser la production. Vous devrez alors valider votre mouvement",
		'context':'MOUVEMENT'
	},
	'allmouvementsvalid': {
		'type':'info',
		'message':"Vous pouvez maintenant procéder à l'installation mais vous avez encore la possibilité de modifier les mouvements.",
		'context':'INSTALLATION'
	},
	'allvalid': {
		'type':'info',
		'message':"Vous pouvez maintenant lancer la simulation  mais vous avez encore la possibilité de modifier l'installation ou les mouvements. Attention, une fois la simulation lancée, vous ne pourrez plus modifier l'installation. De même chaque fois qu'un mouvement sera commencé, toute modification le concernant sera interdite.",
		'context':'SIMULATION'
	}
       /* BC je passe les 2 messages ci-dessou d'un contexte null à 'SIMULATION' */
	,
	'running': {
		'type':'info',
		'message':"Ce mouvement n'a pas encore été simulé, vous pouvez donc le modifier. Notez que vous pourrez corriger votre planification de chantier (ou la recommencer) une fois que la simulation sera allée à son terme.",
		'context':'SIMULATION'
	},
	'runningstarted': {
		'type':'info',
		'message':"Ce mouvement a débuté, vous ne pouvez plus le modifier. Vous pourrez corriger votre planification de chantier (ou la recommencer) une fois que la simulation sera allée à son terme.",
		'context':'SIMULATION'
	}

},

  messagesInstallation : {
	'init': {
		'type':'info',
		'message':"Prévoyez l'ensemble des équipements nécessaires à la bonne marche du chantier en fonction du dimensionnement de ce dernier (taille, personnel, engins …). Validez votre installation quand vous aurez terminé.",
		'context':'INSTALLATION'
	},
	'allvalid': {
		'type':'info',
		'message':"Vous pouvez maintenant lancer la simulation  mais vous avez encore la possibilité de modifier l'installation ou les mouvements. Attention, une fois la simulation lancée, vous ne pourrez plus modifier l'installation. De même chaque fois qu'un mouvement sera commencé, toute modification le concernant sera interdite.",
		'context':'SIMULATION'
	},
	'running': {
		'type':'info',
		'message':"La simulation a été lancée, vous ne pouvez plus modifier l'installation. Vous pourrez corriger votre planification de chantier (ou la recommencer) une fois que la simulation sera allée à son terme.",
		'context':null
	},
	'inhib': {
		'type':'info',
		'message':"Vous pouvez maintenant lancer la simulation partielle. Notez cependant que <span class='avertissement'>dans la réalité, un chantier de cette taille induit obligatoirement une installation</span> et que <span class='avertissement'>vous pourrez réaliser cette installation après la simulation.</span><br/>Vous pouvez encore choisir de réaliser l'installation maintenant ou de modifier les mouvements. Attention, une fois la simulation lancée, chaque fois qu'un mouvement sera commencé, toute modification le concernant sera interdite.",
		'context':'SIMULATION'
	}

},

  messagesAnimation : {
	'allvalid': {
		'type':'info',
		'message':"Vous pouvez maintenant lancer la simulation  mais vous avez encore la possibilité de modifier l'installation ou les mouvements. Attention, une fois la simulation lancée, vous ne pourrez plus modifier l'installation. De même chaque fois qu'un mouvement sera commencé, toute modification le concernant sera interdite.",
		'context':null
	},
	'running': {
		'type':'info',
		'message':"Vous pouvez encore modifier les mouvements qui n'ont pas commencé. Vous pourrez corriger votre planification de chantier (ou la recommencer) une fois que la simulation sera allée à son terme.",
		'context':null
	}

}

}




// WEBPACK FOOTER //
// ./src/client/pages/simulator/simulator-messages.js